import React from 'react';
import { Box, Button, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';

import { WizardLayoutProps } from './types/types';
import { WizardStepper } from './WizardStepper';
import { WizardStep } from './types/types';

import EditIcon from '@material-ui/icons/Edit';
import PolicyRoundedIcon from '@material-ui/icons/PolicyRounded';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import Title from '../Title';
import { WizardButton } from '../ui/WizardButton';

const STEPS: WizardStep[] = [
    { label: 'Build', subLabel: 'Define credential', icon: <EditIcon fontSize="small" /> },
    { label: 'Sign', subLabel: 'Issuer signs', icon: <PolicyRoundedIcon fontSize="small" /> },
    { label: 'Present', subLabel: 'Holder presents', icon: <VisibilityOffIcon fontSize="small" /> },
    { label: 'Verify', subLabel: 'Verifier checks', icon: <VerifiedUserIcon fontSize="small" /> }
];

interface WizardLayoutPropsExtended extends WizardLayoutProps {
    brandIcon?: React.ReactNode;
    brandName?: string;
    brandSub?: string;
    versionBadge?: string;
}

export const WizardLayout: React.FC<WizardLayoutPropsExtended> = ({
    activeStep,
    onStepClick,
    title,
    stepIndicator,
    description,
    onBack,
    onNext,
    backLabel = 'Back',
    nextLabel = 'Next →',
    children,
    brandIcon,
    brandName,
    brandSub,
    versionBadge
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            {(brandName || versionBadge) && (
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Box display="flex" alignItems="center" style={{ gap: 16 }}>
                        {brandIcon && (
                            <Box
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '10px',
                                    width: 38,
                                    height: 38,
                                    backgroundColor: '#2ec4b6'
                                }}>
                                {brandIcon}
                            </Box>
                        )}

                        {brandName && (
                            <Box>
                                <Title>{brandName}</Title>

                                {brandSub && <Typography variant="body2">{brandSub}</Typography>}
                            </Box>
                        )}
                    </Box>

                    {versionBadge && <Typography variant="body2">{versionBadge}</Typography>}
                </Box>
            )}

            <WizardStepper steps={STEPS} activeStep={activeStep} onStepClick={onStepClick} />

            <Paper
                elevation={0}
                style={{
                    display: 'flex',
                    marginTop: 24,
                    border: '1px solid #2ec4b6',
                    borderRadius: 12
                }}>
                {/* Left */}
                <Box flex={1} style={{ padding: isMobile ? '16px' : '32px' }}>
                    {stepIndicator && (
                        <Typography
                            variant="body2"
                            style={{
                                textTransform: 'uppercase',
                                fontSize: '11px',
                                color: '#26a9a9',
                                fontWeight: 600,
                                letterSpacing: '0.2em'
                            }}>
                            {stepIndicator}
                        </Typography>
                    )}

                    <Typography style={{ fontSize: isMobile ? 18 : 22, color: '#000000' }}>
                        {title}
                    </Typography>

                    {description && (
                        <Typography style={{ fontSize: 12, color: '#5a6272' }}>
                            {description}
                        </Typography>
                    )}

                    <Box mt={3}>{children}</Box>

                    <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                            {onBack && (
                                <Button variant="outlined" onClick={onBack}>
                                    {backLabel}
                                </Button>
                            )}
                        </Box>

                        <Box>
                            {onNext && (
                                <WizardButton variant="contained" onClick={onNext}>
                                    {nextLabel}
                                    <span style={{ display: 'flex' }}>
                                        <ArrowRightAltIcon fontSize="small" />
                                    </span>
                                </WizardButton>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};
